<template>
    <div class="contact-icons">
        <component :is="isActionElement(socialLink) ? 'div' : 'a'"
                   v-for="socialLink in menuStore.mobileMenuFooterData.socialLinks"
                   :key="socialLink.name"
                   class="contact-icon"
                   :href="isActionElement(socialLink) ? null : socialLink.action_url ?? socialLink.url"
                   rel="nofollow noopener noindex"
                   target="_blank"
                   :aria-label="socialLink.name"
                   @click="handleClick(socialLink)">
            <i :class="socialLink.icon" />
        </component>
    </div>
</template>

<script setup lang="ts">
    import { useMenuStore } from '@/js/store/menu/MenuStore';
    import { ISocialLink } from '../types/menuFooterTypes';
    import { useSubscribeModalStore } from '@/js/store/subscribe/SubscribeModalStore';

    const menuStore = useMenuStore();
    const subscribeModalStore = useSubscribeModalStore();

    const isActionElement = (element: ISocialLink) => element?.action;

    const handleClick = (element) => {
        if (isActionElement(element)) {
            subscribeModalStore.setSubscribeModal(true, true);
        }
    };
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;

.contact-icons {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 80px;
    gap: 8px;

    .contact-icon {
        display: flex;
        width: 40px;
        height: 40px;
        align-items: center;
        justify-content: center;
        padding: 5px;
        border-radius: 50%;
        background-color: legacyVariables.$light;
        cursor: pointer;

        i {
            color: legacyVariables.$body-color;
        }
    }
}

.dark-theme {
    .contact-icons {
        .contact-icon {
            background: legacyVariables.$dark-theme-medium-purple;

            i {
                color: legacyVariables.$white;
            }
        }
    }
}
</style>
